const MEDIA_ITEMS = [
  {
    title: '明星红毯名场面合集',
    duration: '15:32',
    views: '38.6万',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20red%20carpet%20event%20with%20golden%20warm%20lighting%2C%20elegant%20photography%20backdrop%2C%20glamorous%20atmosphere%2C%20award%20ceremony%20aesthetic%2C%20cinematic%20wide%20shot%2C%20no%20people%20faces&width=800&height=500&seq=media-01&orientation=landscape',
    tag: '红毯',
  },
  {
    title: '综艺录制幕后花絮独家',
    duration: '22:08',
    views: '25.1万',
    image: 'https://readdy.ai/api/search-image?query=Television%20production%20behind%20the%20scenes%20with%20cameras%20and%20equipment%2C%20warm%20studio%20lighting%2C%20professional%20broadcast%20atmosphere%2C%20cinematic%20documentary%20style%2C%20no%20people&width=800&height=500&seq=media-02&orientation=landscape',
    tag: '幕后',
  },
  {
    title: '粉丝接机现场混乱名场面',
    duration: '08:45',
    views: '42.3万',
    image: 'https://readdy.ai/api/search-image?query=Busy%20airport%20arrival%20gate%20with%20warm%20interior%20lighting%2C%20crowded%20atmosphere%2C%20dynamic%20energy%2C%20celebrity%20fan%20culture%20theme%2C%20editorial%20photography%2C%20motion%20blur%20effect&width=800&height=500&seq=media-03&orientation=landscape',
    tag: '现场',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">现场直击</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            高清吃瓜现场视频，带你第一视角直击明星大瓜名场面
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-2xl md:text-3xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-black/50 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}